import { useCallback, useMemo } from 'react';

import {
  DropdownPopover,
  MyCropwiseIcon,
  SearchTreePopover
} from '@/components';
import { useFeatureFlags } from '@/contexts';

import RegionTree from './components/RegionTree';
import { useGetRegionOptions } from './hooks';

type Props = {
  value?: string;
  activeRegion?: string;
  onOpenChange?: (open: boolean) => void;
  onChange: (value: string) => void;
};

const SelectRegion = ({
  value,
  activeRegion,
  onChange,
  onOpenChange
}: Props) => {
  const { options, isLoading } = useGetRegionOptions();
  const { isEnabled } = useFeatureFlags();
  const isSearchTreePopoverEnabled = isEnabled(
    'releaseWebTopbarSearchTreeSelectors'
  );

  const currentOption = useMemo(
    () => options.find(option => option.value === value),
    [options, value]
  );

  const renderRegions = useCallback(
    (searchValue: string, closePopover: () => void) => (
      <RegionTree
        options={options}
        value={activeRegion}
        searchValue={searchValue}
        onChange={region => {
          onChange(region);
          closePopover();
        }}
      />
    ),
    [options, activeRegion, onChange]
  );

  if (isSearchTreePopoverEnabled) {
    return (
      <SearchTreePopover
        title='Region'
        placeholder='Select a region'
        currentValue={currentOption?.label}
        icon={<MyCropwiseIcon />}
        onOpenChange={onOpenChange}
        isLoading={isLoading}>
        {(searchValue, closePopover) =>
          renderRegions(searchValue, closePopover)
        }
      </SearchTreePopover>
    );
  }

  return (
    <DropdownPopover
      isLoading={isLoading}
      options={options}
      currentValue={value}
      onConfirm={onChange}
      label='Select a Region'
      title='Region'
    />
  );
};

export default SelectRegion;
